import React from "react";
import { Box, HStack, Text, Spinner } from "@chakra-ui/react";
import Select from "react-select";
import styles from "components/Styles/AsmStyles.js";

export function FilterBar({
  regionOptions, asmOptions, cityOptions, channelOptions, typeOptions,
  // Selections
  selectedRegions, setSelectedRegions,
  selectedAsm, setSelectedAsm,
  selectedDistrict, setSelectedDistrict,
  selectedChannels, setSelectedChannels,
  selectedTypes, setSelectedTypes,
  // Loading
  loadingRegions, loadingSubRegion, loadingCity, loadingChannel, loadingType,
  fromDate, toDate,
  // Outlet count
  totalOutlets, loadingScores,
}) {
  return (
    <HStack
      spacing={{ base: 3, md: 5 }}
      align="flex-start"
      flexDir={{ base: "column", lg: "row" }}
    >
      <Box flex="1" width={{ base: "100%", lg: "auto" }} mb={{ base: 3, lg: 0 }} borderRadius="8px">
        <Select
          isMulti
          options={regionOptions}
          value={selectedRegions}
          onChange={(value) => setSelectedRegions(value || [])}
          placeholder="Company Code"
          closeMenuOnSelect={false}
          isClearable
          isLoading={loadingRegions}
          isDisabled={loadingRegions || (!fromDate && !toDate)}
          styles={styles.customSelectStyles}
        />
      </Box>

      <Box flex="1" width={{ base: "100%", lg: "auto" }} mb={{ base: 3, lg: 0 }}>
        <Select
          isMulti
          options={asmOptions}
          value={selectedAsm}
          onChange={(value) => setSelectedAsm(value || [])}
          placeholder="ASM"
          closeMenuOnSelect={false}
          isLoading={loadingSubRegion}
          isDisabled={selectedRegions.length === 0}
          styles={styles.customSelectStyles}
        />
      </Box>

      <Box flex="1" width={{ base: "100%", lg: "auto" }} mb={{ base: 3, lg: 0 }}>
        <Select
          isMulti
          options={cityOptions}
          value={selectedDistrict}
          onChange={(value) => setSelectedDistrict(value || [])}
          placeholder="Cities"
          closeMenuOnSelect={false}
          isLoading={loadingCity}
          isDisabled={selectedAsm.length === 0}
          styles={styles.customSelectStyles}
        />
      </Box>

      <Box flex="1" width={{ base: "100%", lg: "auto" }} mb={{ base: 3, lg: 0 }}>
        <Select
          isMulti
          options={channelOptions}
          value={selectedChannels}
          onChange={(value) => setSelectedChannels(value || [])}
          placeholder="Channels"
          closeMenuOnSelect={false}
          isLoading={loadingChannel}
          isDisabled={selectedDistrict.length === 0}
          styles={styles.customSelectStyles}
        />
      </Box>

      <Box flex="1" width={{ base: "100%", lg: "auto" }} mb={{ base: 3, lg: 0 }}>
        <Select
          isMulti
          options={typeOptions}
          value={selectedTypes}
          onChange={(value) => setSelectedTypes(value || [])}
          placeholder="Type"
          closeMenuOnSelect={false}
          isLoading={loadingType}
          isDisabled={selectedChannels.length === 0}
          styles={styles.customSelectStyles}
        />
      </Box>

      <Box
        bg="gray.800"
        color="white"
        px="4"
        py="3"
        borderRadius="lg"
        minW="150px"
        textAlign="center"
        fontWeight="bold"
        boxShadow="sm"
        width={{ base: "100%", lg: "auto" }}
      >
        <Text fontSize="sm" opacity={0.9}>Total Outlets</Text>
        <Text fontSize="2xl" fontWeight="bold">
          {loadingScores ? <Spinner size="sm" /> : totalOutlets}
        </Text>
      </Box>
    </HStack>
  );
}
